import React, { useState, useEffect } from 'react';
import ProductCard from '../product-card.jsx';
import ConfiguratorOption from './ConfiguratorOption.jsx';
import { getProductFilterOptions, getFilteredProductsByClassification } from '../../../../shared/apis/filters';
import toast from '../../../../shared/components/toast';
import LoaderSection from '../../../../shared/react/components/loader-section.jsx';
import FilterDetails from './filter-badges.js';
function App(props) {

    const [doShowProducts, setDoShowProducts] = useState(false);
    const [step, setStep] = useState('power');
    const [phaseOptions, setPhaseOptions] = useState([]);
    const [hzOptions, setHzOptions] = useState([]);
    const [voltageOptions, setVoltageOptions] = useState([]);
    const [coolingOptions, setCoolingOptions] = useState([]);
    const [availableProducts, setAvailableProducts] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showExplainThis, setShowExplainThis] = useState(false);


    const handleBack = () => {
        const updatedFilters = [...selectedFilters];
        updatedFilters.pop();
        setSelectedFilters(updatedFilters);
        if (step == 'hz') setStep('power');
        else if (step == 'voltage') setStep('hz')
        else if (step == 'cooling') setStep('voltage')
        else if (step == 'final') setStep('cooling');;
    }

    useEffect(() => {
        setShowExplainThis(false);
        const params = {
            page: 1,
            pageSize: 30,
            selected: selectedFilters.join(',')
        }
        setIsLoading(true);
        getProductFilterOptions(props.nodeId, params)
            .then(data => {
                console.log("productFilterOptions",  data.Phase)
                setPhaseOptions(data.Phase);
                setHzOptions(data.Hz);
                setVoltageOptions(data.Voltage);
                setCoolingOptions(data.Cooling);

            })
            .catch(error => {
                console.log(error);
                toast.error('There was an error getting filters');
            })
            .finally(() => {
                setIsLoading(false);
            });

        getFilteredProductsByClassification(props.nodeId, params)
            .then(data => {
                setAvailableProducts(data.records);
                setTotalRecords(data.totalRecords);
            })
            .catch(error => {
                console.log(error);
                toast.error('There was an error getting products');
            });
    }, [selectedFilters]);


    const handlePhaseSelection = (guid) => {
        setSelectedFilters((selectedFilters) => [...selectedFilters, guid]);
        setStep('hz');
    }

    const handleHzSelection = (guid) => {
        setSelectedFilters((selectedFilters) => [...selectedFilters, guid]);
        setStep('voltage');
    }

    const handleVoltageSelection = (guid) => {
        setSelectedFilters((selectedFilters) => [...selectedFilters, guid]);
        setStep('cooling');
    }

    const handleCoolingSelection = (guid) => {
        setSelectedFilters((selectedFilters) => [...selectedFilters, guid]);
        setStep('final');
        setDoShowProducts(true);
    }

    const handleStartOver = () => {
        if (confirm("Are you sure you want to reset your options and start over?")) {
            setSelectedFilters([]);
            setStep('power');
            setDoShowProducts(false);
        }
    }

    const renderFinalOptions = () => {
        let phase = phaseOptions.find(option => option.filterGuid === selectedFilters[0])
        let hz = hzOptions.find(option => option.filterGuid === selectedFilters[1])
        let voltage = voltageOptions.find(option => option.filterGuid === selectedFilters[2])
        let cooling = coolingOptions.find(option => option.filterGuid === selectedFilters[3])

        return <>
            <ConfiguratorOption image={FilterDetails.phaseDetails[phase.value].img} title={FilterDetails.phaseDetails[phase.value].title} />
            <ConfiguratorOption image={FilterDetails.hzDetails[hz.value].img} title={FilterDetails.hzDetails[hz.value].title} />
            <ConfiguratorOption image={FilterDetails.voltageDetails[voltage.value].img} title={FilterDetails.voltageDetails[voltage.value].title} />
            <ConfiguratorOption image={FilterDetails.coolingDetails[cooling.value].img} title={FilterDetails.coolingDetails[cooling.value].title} />
        </>


    }

    const renderExplainThisText = () => {

        let explainText = showExplainThis ? 'CLOSE' : 'EXPLAIN THIS';
        switch (step) {
            case ('power'):
                return <div className={`explain-this-text ${showExplainThis ? 'slide-in' : 'slide-out'}`} >
                    <div onClick={_ => setShowExplainThis(!showExplainThis)} className={`explain-this ${showExplainThis ? 'open' : ''}`}>{explainText}</div>
                    {showExplainThis ? (
                        <>
                            <div className="explain-this-text-inner ">
                                Do you have single-phase or three-phase power? If unsure, check your electrical panel, read your meter, or ask your electrician or building manager.<br /><br />
                                Single phase is often found in homes or to power lighter loads. On a single-phase electrical switchboard, a main switch will be 1 or 2 poles wide.<br /><br />
                                Three phase provides higher sustained power for large electric motors. On a three-phase switchboard, a main switch will be 3 poles wide.
                            </div>
                            <div className="overlay"></div>
                        </>

                    )
                        : (
                            <div style={{ padding: '0 40px', transform: 'translate(-100%)' }}>Find your perfect {props.title}</div>
                        )

                    }
                </div>;
            case ('hz'):
                return <div className={`explain-this-text ${showExplainThis ? 'slide-in' : 'slide-out'}`}>
                    <div onClick={_ => setShowExplainThis(!showExplainThis)} className={`explain-this ${showExplainThis ? 'open' : ''}`}>{explainText}</div>
                    {showExplainThis ?
                        <div className="explain-this-text-inner">
                            Hertz is based on your country’s electrical standard. Below are guidelines to help you determine which unit of frequency may apply to your area.<br /><br />
                            <strong>60 Hz</strong> is common in North America, parts of South America, and some Asian countries.<br /><br />
                            <strong>50 Hz</strong> is the standard in Europe, most of Asia, Africa, and Australia.
                        </div>
                        :
                        <div style={{ padding: '0 40px', transform: 'translate(-100%)' }}>Find your perfect {props.title}</div>
                    }
                </div>;
            case ('voltage'):
                return <div className={`explain-this-text ${showExplainThis ? 'slide-in' : 'slide-out'}`}>
                    <div onClick={_ => setShowExplainThis(!showExplainThis)} className={`explain-this ${showExplainThis ? 'open' : ''}`}>{explainText}</div>
                    {showExplainThis ?
                        <div className="explain-this-text-inner">
                            <p>Start by selecting your available voltage using the guidelines below.  If unsure, check your outlet rating or ask your electrician. <br /><br /></p>

                            <p><strong>115V</strong> is standard in U.S. homes.</p>

                            <p><strong>208V-240V</strong> is common in U.S. commercial settings.</p>

                            <p><strong>220V-240V</strong> is standard in Europe</p>

                            <p><strong>380V-414V</strong> is often found in industrial use</p>

                        </div>
                        :
                        <div style={{ padding: '0 40px', transform: 'translate(-100%)' }}>Find your perfect {props.title}</div>
                    }
                </div>;
            case ('cooling'):
                return <div className={`explain-this-text ${showExplainThis ? 'slide-in' : 'slide-out'}`}>
                    <div onClick={_ => setShowExplainThis(!showExplainThis)} className={`explain-this ${showExplainThis ? 'open' : ''}`}>{explainText}</div>
                    {showExplainThis ?
                        <div className="explain-this-text-inner">
                            Select a cooling type based on your space and needs. Following are considerations to help you determine which type will best suit you.<br /><br />
                            <strong>Air-cooled</strong> equipment is easier to install and relocate, with lower upfront costs.<br /><br />
                            <strong>Water-cooled</strong> machines feature quieter operation without fans, provide consistent performance in hot/enclosed spaces, and won’t add heat to your roof.<br /><br />
                            <strong>Remote air-cooled</strong> models operate without adding heat or noise in interior spaces (ideal for customer-facing areas), provide the best high-volume performance, and reduce indoor HVAC load.

                        </div>
                        :
                        <div style={{ padding: '0 40px', transform: 'translate(-100%)' }}>Find your perfect {props.title}</div>
                    }
                </div>;
            case ('final'):
                return <div className={`explain-this-text ${showExplainThis ? 'slide-in' : 'slide-out'}`}>
                    <div onClick={_ => setShowExplainThis(!showExplainThis)} className={`explain-this ${showExplainThis ? 'open' : ''}`}>{explainText}</div>
                    {showExplainThis ?
                        <div className="explain-this-text-inner">
                            Thank you, you have reached the final step, and the available products are being shown below.
                        </div>
                        :
                        <div style={{ padding: '0 40px', transform: 'translate(-100%)' }}>Find your perfect {props.title}</div>
                    }
                </div>;
            default:
                return <></>;
        }
    }

    return (
        <>
            <div id="genus-product-configurator">
                <div className={`left-column ${showExplainThis ? 'open' : ''}`}>
                    {renderExplainThisText()}

                </div>

                <div className="right-column">

                    {step == 'power' &&
                        <>
                            <div className="step-heading">
                                <strong>Step 1 out of 4</strong> (We found {totalRecords} products available)
                            </div>

                            <div className="heading">Select the power type</div>

                            <div className="icons">
                                {isLoading ? (
                                    <div className="loader-section" style={{ width: '100%' }}>
                                        <div className="loader show">
                                            <LoaderSection show={true} />
                                        </div>
                                    </div>
                                ) : (
                                    phaseOptions && phaseOptions.length > 0 ? (
                                        phaseOptions.map((option, index) => {
                                            let title = FilterDetails.phaseDetails[option.value].title;
                                            let img = FilterDetails.phaseDetails[option.value].img;
                                            return (
                                                <ConfiguratorOption
                                                    image={img}
                                                    filterGuid={option.filterGuid}
                                                    title={title}
                                                    productCount={option.numberOfProducts}
                                                    onSelect={handlePhaseSelection}
                                                />
                                            );
                                        })
                                    ) : (
                                        <div>No phase options available.</div>
                                    )
                                )}
                            </div>
                        </>
                    }

                    {step == 'hz' &&
                        <>
                            <div className="step-heading">
                                <strong>Step 2 out of 4</strong> (We found {totalRecords} products available)
                            </div>

                            <div className="heading">Select the Hz type</div>

                            <div className="icons">
                                {isLoading ? (
                                    <div className="loader-section" style={{ width: '100%' }}>
                                        <div className="loader show">
                                            <LoaderSection show={true} />
                                        </div>
                                    </div>
                                ) : (
                                    hzOptions && hzOptions.length > 0 ? (
                                        hzOptions.map((option) => {
                                            let title = FilterDetails.hzDetails[option.value].title;
                                            let img = FilterDetails.hzDetails[option.value].img;
                                            return <ConfiguratorOption image={img} filterGuid={option.filterGuid} title={title} productCount={option.numberOfProducts} onSelect={handleHzSelection} />
                                        })
                                    ) : (
                                        <div>No hz options available.</div>
                                    )
                                )}
                            </div>
                        </>
                    }

                    {step == 'voltage' &&
                        <>
                            <div className="step-heading">
                                <strong>Step 3 out of 4</strong> (We found  {totalRecords} products available)
                            </div>

                            <div className="heading">Select the voltage type</div>

                            <div className="icons">

                                {isLoading ? (
                                    <div className="loader-section" style={{ width: '100%' }}>
                                        <div className="loader show">
                                            <LoaderSection show={true} />
                                        </div>
                                    </div>
                                ) : (
                                    voltageOptions && voltageOptions.length > 0 ? (
                                        voltageOptions.map((option) => {
                                            let title = FilterDetails.voltageDetails[option.value].title;
                                            let img = FilterDetails.voltageDetails[option.value].img;
                                            return <ConfiguratorOption image={img} filterGuid={option.filterGuid} title={title} productCount={option.numberOfProducts} onSelect={handleVoltageSelection} />
                                        })
                                    ) : (
                                        <div>No voltage options available.</div>
                                    )
                                )}
                            </div>
                        </>
                    }

                    {step == 'cooling' &&
                        <>
                            <div className="step-heading">
                                <strong>Step 4 out of 4</strong> (We found  {totalRecords} products available)
                            </div>

                            <div className="heading">Select the machine cooling type</div>

                            <div className="icons">                            
                                {isLoading ? (
                                    <div className="loader-section" style={{ width: '100%' }}>
                                        <div className="loader show">
                                            <LoaderSection show={true} />
                                        </div>
                                    </div>
                                ) : (
                                    coolingOptions && coolingOptions.length > 0 ? (
                                        coolingOptions.map((option) => {
                                            let title = FilterDetails.coolingDetails[option.value].title;
                                            let img = FilterDetails.coolingDetails[option.value].img;
                                            return <ConfiguratorOption image={img} filterGuid={option.filterGuid} title={title} productCount={option.numberOfProducts} onSelect={handleCoolingSelection} />
                                        })
                                    ) : (
                                        <div>No cooling options available.</div>
                                    )
                                )}
                            </div>
                        </>
                    }


                    {step == 'final' &&
                        <>
                            <div className="step-heading">
                                We found <strong>{totalRecords} Product(s)</strong> based on your choices.
                            </div>
                            <div className="heading">Your selected options</div>

                            <div className="icons">
                                {renderFinalOptions()}
                            </div>

                        </>
                    }

                    <div className="buttons-container">
                        {step !== 'power' &&
                            <>
                                <button className="solid" onClick={handleBack}>Back</button>
                                <button className="outline" onClick={handleStartOver}>Start Over</button>
                            </>
                        }
                        <button className="solid" onClick={_ => setDoShowProducts(!doShowProducts)}>{doShowProducts ? "Hide Products" : "Show Products"}</button>
                    </div>

                </div>
            </div>


            {doShowProducts &&
                <div id="genus-configurator-results">
                    <div className="title">Available Products</div>
                    {availableProducts.length === 0 &&
                        <p style={{ marginTop: '10px' }}>No products available matching your configuration.</p>
                    }

                    <div className="container">
                        <div className="row">
                            {isLoading ?
                                <div className="loader-section" style={{ width: '100%' }}>
                                    <div className="loader show">
                                        <LoaderSection show={true} />
                                    </div>
                                </div> :
                                availableProducts.map((product) => {
                                    const img = product.thumbnail ? product.thumbnail : "https://embed.widencdn.net/img/vollrath/j8hhfhfgqr/x220px@2x/PRO_Photo_Missing_glm_11_22.jpeg?q=80";
                                    return <ProductCard discontinued={product.discontinued} pageUrl={product.pageUrl} thumbnail={img} itemNumber={product.itemNumber} productName={product.productName} />
                                })
                               
                            }
                        
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default App;